import { gql, useQuery } from '@apollo/client';

export const GET_CUSTOMER_BY_ID = gql`
  query ($companyId: String!, $customerId: String!) {
    getCustomerById(companyId: $companyId, customerId: $customerId) {
      _id
      salutation
      customerName
      companyName
      contactPersons {
        name
        email
        phoneNumber
      }
      notes
      email
      phoneNumber
      mobilePhoneNumber
      address {
        country
        city
        street
        zipCode
      }
      createdAt
      createdBy
    }
  }
`;

export const useGetCustomerById = (customerId: string, companyId?: string) => {
  const { data, loading } = useQuery(GET_CUSTOMER_BY_ID, {
    variables: {
      customerId,
      companyId,
    },
    skip: !companyId,
  });

  const customer = data?.getCustomerById || {};

  return {
    customer,
    loading,
  };
};
